import React, { useState, useEffect, useRef } from 'react';
import "../assest/StoreStoryModal.css";

const StoreStoryModal = ({ isOpen, onClose, store, stories }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [startX, setStartX] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const modalRef = useRef(null);

  // Modal açıldığında index'i sıfırla ve body scroll'u engelle
  useEffect(() => {
    if (isOpen) {
      setCurrentIndex(0);
      // Body scroll'u engelle
      document.body.style.overflow = 'hidden';
    } else {
      // Modal kapandığında scroll'u geri aç
      document.body.style.overflow = 'unset';
    }

    // Cleanup function - component unmount olduğunda scroll'u geri aç
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen || !store) return null;
  
  // Eğer stories yoksa veya boşsa, tek story oluştur
  const storyList = stories && stories.length > 0 ? stories : [{
    story_image: store.image,
    story_url: null,
    created_at: new Date().toISOString()
  }];

  const currentStory = storyList[currentIndex];

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  // Swipe event handlers
  const handleTouchStart = (e) => {
    setStartX(e.touches[0].clientX);
    setIsDragging(true);
  };

  const handleTouchMove = (e) => {
    if (!isDragging) return;
    e.preventDefault();
  };

  const handleTouchEnd = (e) => {
    if (!isDragging) return;
    
    const endX = e.changedTouches[0].clientX;
    const diffX = startX - endX;
    const threshold = 50; // Minimum swipe distance

    if (Math.abs(diffX) > threshold) {
      if (diffX > 0) {
        // Swipe left - next story
        nextStory();
      } else {
        // Swipe right - previous story
        prevStory();
      }
    }
    
    setIsDragging(false);
  };

  // Mouse events for desktop
  const handleMouseDown = (e) => {
    setStartX(e.clientX);
    setIsDragging(true);
  };

  const handleMouseUp = (e) => {
    if (!isDragging) return;
    
    const endX = e.clientX;
    const diffX = startX - endX;
    const threshold = 50;

    if (Math.abs(diffX) > threshold) {
      if (diffX > 0) {
        nextStory();
      } else {
        prevStory();
      }
    }
    
    setIsDragging(false);
  };

  const nextStory = () => {
    if (currentIndex < storyList.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const prevStory = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  const handleProductClick = () => {
    // Story URL'i varsa o ürüne yönlendir, yoksa mağaza ürünlerine yönlendir
    if (currentStory.story_url) {
      window.location.href = currentStory.story_url;
    } else {
      window.location.href = `/${store.magaza_sef}/all`;
    }
  };

  const handleStoreClick = () => {
    // Mağaza sayfasına yönlendir
    window.location.href = `/${store.magaza_sef}/all`;
  };

  return (
    <div className="store-story-modal-overlay" onClick={handleOverlayClick}>
      <div 
        className="store-story-modal"
        ref={modalRef}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
        onMouseDown={handleMouseDown}
        onMouseUp={handleMouseUp}
      >
        {/* Kapatma butonu */}
        <button 
          className="store-story-close-btn"
          onClick={onClose}
          aria-label="Kapat"
        >
          ✕
        </button>

        {/* Story göstergeleri ve counter */}
        {storyList && storyList.length > 1 && (
          <div className="store-story-indicators">
            <div className="store-story-dots">
              {storyList.map((_, index) => (
                <div
                  key={index}
                  className={`store-story-indicator ${index === currentIndex ? 'active' : ''}`}
                  onClick={() => setCurrentIndex(index)}
                />
              ))}
            </div>
            <div className="store-story-counter">
              {currentIndex + 1} / {storyList.length}
            </div>
          </div>
        )}

        {/* Story resmi */}
        <div className="store-story-image-container">
          <img 
            src={currentStory.story_image || store.image} 
            alt={`${store.magaza_adi} story`}
            className="store-story-image"
          />
        </div>

        {/* Alt butonlar */}
        <div className="store-story-buttons">
          <button 
            className="store-story-btn store-story-btn-primary"
            onClick={handleProductClick}
          >
            Ürüne Git
          </button>
          <button 
            className="store-story-btn store-story-btn-secondary"
            onClick={handleStoreClick}
          >
            Mağazaya Git
          </button>
        </div>

        {/* Mağaza bilgisi */}
        <div className="store-story-info">
          <h3 className="store-story-title">{store.magaza_adi}</h3>
        </div>

        {/* Navigation arrows */}
        {storyList && storyList.length > 1 && (
          <>
            {currentIndex > 0 && (
              <button 
                className="store-story-nav store-story-nav-left"
                onClick={prevStory}
                aria-label="Önceki story"
              >
                ‹
              </button>
            )}
            {currentIndex < storyList.length - 1 && (
              <button 
                className="store-story-nav store-story-nav-right"
                onClick={nextStory}
                aria-label="Sonraki story"
              >
                ›
              </button>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default StoreStoryModal;
